import { useCallback, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { API_URL } from "../_services/apiUrl";
import Layout from "./Shared/Layout";
import { get, imageurl } from "../_services/apiService";

const SubCategory = () => {
    const productCategoryId = localStorage.getItem('productCategoryId');
    const [subCategoryData, setSubCategoryData] = useState([]);
    const navigate = useNavigate();

    const GetProductDetailById = useCallback(async () => {
        try {

            let url = productCategoryId === null
                ? API_URL?.GetProductSubCategory
                : `${API_URL?.GetProductSubCategoryByCategoryId}?pProductCategoryId=${productCategoryId}`;

            const response = await get(url);
            if (response.isSuccess === 200) {
                setSubCategoryData(response.data);
            } else {
                toast.error(response.message || 'Login failed. Please check your credentials.');
            }
        } catch (error) {
            toast.error('An error occurred. Please try again later.');
        }
    }, [productCategoryId]);

    useEffect(() => {
        GetProductDetailById();
    }, [GetProductDetailById]);

    const onProductBySubCategoryId = (item) => {
        localStorage.setItem('productSubCategoryId', item?.productSubCategoryId);
        navigate(`/${item?.categoryName.replace(/\s+/g, '_')}/${item?.productSubCategoryName.replace(/\s+/g, '_')}`);
        localStorage.setItem('priviousUrl', `/${item?.categoryName.replace(/\s+/g, '_')}/${item?.productSubCategoryName.replace(/\s+/g, '_')}`);
    };

    return (
        <Layout>
            <section className="same_space">
                <div className="container">
                    <div className="row">
                        {subCategoryData.map((item, index) => (
                            <div key={index} className="slider-item col-xl-3 col-sm-4 col-6 mb-4" onClick={()=>onProductBySubCategoryId(item)}>
                                <img src={item?.imgPath ? `${imageurl}${item.imgPath}` : '/images/defaultImage.png'} className="w-100" alt="" />
                                <p className="data-title">{item.displayName}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </Layout >
    )
}

export default SubCategory;